module.exports = __webpack_public_path__ + "cancellara-dist/img/willis.1a087867.png";